import { Data_Export_Schedule_Execution_Status_Enum } from '@risksmart-app/web-graphql-client/generated/graphql';

/**
 * Until RSP-6624 the executor derived a run's `ExecutionTimestamp` from the
 * stored `scheduled` row rather than from the run's own day, so a completed run
 * recorded its `complete` status against the NEXT run's slot. Those rows are
 * still in customer data and there is no backfill, so the history table would
 * otherwise advertise a run that is not yet due as already finished.
 *
 * `cancelled` is deliberately left alone — a pending future row IS cancelled
 * when its schedule is deactivated, so that combination is legitimate.
 */
export const deriveExecutionDisplayStatus = (
  status: Data_Export_Schedule_Execution_Status_Enum,
  executionTimestamp: string,
  now: Date = new Date()
): Data_Export_Schedule_Execution_Status_Enum =>
  status === Data_Export_Schedule_Execution_Status_Enum.Complete &&
  new Date(executionTimestamp).getTime() > now.getTime()
    ? Data_Export_Schedule_Execution_Status_Enum.Scheduled
    : status;
